define('commons/wizard/wizard',['jquery', 'commons/wizard/wizard-page'], function($, WizardPage) {

    /**
      A Wizard is composed by some WizardPages.
      Each page represents a step, and could be valid(then can flip to the next page) or not(can't go next).
      The html structure shall be composed as follows : 

       <div class = "wizard">
           <form:form commandName="myForm">
            
                <!-- global errors -->
               <form:errors class="error hidden"/>
               
               <div class="wizard-page hidden">
                   <input type="hidden" name="myHiddenId" id="myHiddenId"/>
                   <a href="javascript:void(0);" data-hidden-input-value="My Value" data-hidden-input-id="myHiddenId" data-page-change-trigger="#page-2"></a>
               </div>
               <div class="wizard-page" >
                    <div class="wizard-form">
                        <div class="wizard-form-field-block">
                            <label for="inputId">My label</label>
                            <input type="text" name="inputId"/>
                        </div>
                    </div>
               </div>
               ... Other pages ... 
           </form:form>
       </div>
       
       
       Data-* attributes :
           => Wizard page 
                - data-page-title : the page title displayed in the steps bar
                - data-page-description : the page description
                - data-show-next : boolean, false if the Next button should be displayed
                - data-show-back : boolean, false if the Back button should be displayed
           => On a page field 
                - data-hidden-input-value/data-hidden-input-id :
                  Used when you want to set the value of a hidden input with id = data-hidden-input-id to data-hidden-input-value on click. 
                - data-page-change-trigger : string, the target page id. When this field is clicked the target page is loaded.
       
       It's pretty much everything for now...
     */
        
    var Wizard = function(container, options) {
        this.CONSTANTS = (function() {
            var privateConstants = {
                'NONE': -1,
                'BACK_BTN_ID' : '#back-btn',
                'NEXT_BTN_ID' : '#next-btn'
            };

            return {
                get: function(name) {
                    return privateConstants[name];
                }
            };
        })();
        
        this.options = $.extend({
            height : '600px' ,
            // Could be defined by creator,
            // default behavior is a basic ++ on the current page index
            getNextPageIndex : function( wizard ){
                if( wizard.pages[wizard.currentPageIndex + 1] ){
                    return wizard.currentPageIndex + 1;
                }
                return wizard.CONSTANTS.get('NONE');
            },
            // Could be defined by creator,
            // default behavior is a basic -- on the current page index
            getPreviousPageIndex : function( wizard ){
                if( wizard.pages[wizard.currentPageIndex - 1] ){
                    return wizard.currentPageIndex - 1;
                }
                return wizard.CONSTANTS.get('NONE');
            },
            enctype : 'application/x-www-form-urlencoded',
            method : 'post',
            action : '',
            submitBtnText : 'Submit'
        }, options);
        
        // WizardPage[]
        this.pages = [];
        this.currentPageIndex = this.CONSTANTS.get('NONE');
        this.$container = $(container).css('min-height', this.options.height);
        
        this._init( container, options );
    };
    
    /**
     * Entry point, big initializer, alpha and omega. Enlighten me then...
     */
    Wizard.prototype._init = function( container, options ){
        // Create all WizardPages
        this._addPages();
        
        var $pages = this.$container.find('.wizard-page');
        
        // Top bar with all steps displayed
        this._addStepsBar();
        
        // Page title + description + icon
        this._addDescriptionPanel();
        
        // Page content
        this._addContentPanel( $pages );
        
        // Add control buttons
        this._addButtonsBar();
        
        // Bind custom triggers, <a> tag for instance that doesn't the direct next page
        // e.g. On page 1, there's a <a> tag that shows Page 3 when clicked (instead of page 2).
        this._bindCustomTriggers();
        
        // enctype, action, method...
        this._updateFormAttributes( this.options.enctype, this.options.action, this.options.method);
        
        // Show global errors if existing, retriver the index of the first page which contains errors
        var firstPageOnErrorIndex = this._displayErrors();
        
        // Show first page with errors if any
        this.goToPageIndex(firstPageOnErrorIndex);
    };
    
    Wizard.prototype._addDescriptionPanel = function(){
        var $wrapper = $('<div class="wizard-description-wrapper"></div>');
        var $descriptionPanel = $('<div class="hidden wizard-description-panel subscription-description-text"></div>');
        var $iconPanel = $('<img class="hidden wizard-description-icon"/>');
        
        $wrapper.append($descriptionPanel).append($iconPanel);
        this.$container.append($wrapper);
    };
    
    Wizard.prototype._addContentPanel = function( $pages ){
        this.$form = this.$container.find('form');
        var $content = $('<div class="wizard-content"></div>').append( this.$form );
        this.$form.append($pages);
        this.$container.append($content);
    };
    
    Wizard.prototype._addStepsBar = function(){
        this.$stepsBar = $('<div class="wizard-steps-bar"></div>');
        
        for (var i = 0; i < this.pages.length; i++) {
            var page = this.pages[i];
            this.$stepsBar.append($('<a class="wizard-step" data-page-selector="' + page.id + '" href="javascript:void(0);" data-page-change-trigger="' + page.id + '">' + page.title + '</a>'));
        }
        
        this.$container.append( this.$stepsBar );
    };
    
    Wizard.prototype._addPages = function(){
        var pages = this.$container.find('.wizard-page');
        for (var i = 0; i < pages.length; i++) {
            var $page = $(pages[i]);
            var showNext = typeof $page.data('showNext') !== 'undefined' ? $page.data('showNext') : true;
            // First page has no previous btn
            var showPrevious = i === 0 ? false : (typeof $page.data('showBack') !== 'undefined' ? $page.data('showBack') : true);
            
            this.pages.push( new WizardPage( $page.attr('id'), $page.data('pageTitle'), $page.data('pageDescription'), $page.data('pageIcon'), {
                showNextButton : showNext,
                showPreviousButton : showPrevious
            }));
        }
    };
    
    Wizard.prototype._addButtonsBar = function(){
        var $buttonsBar = $('<div class="wizard-buttons-bar">' +
                                '<button type="button" id="' + this.CONSTANTS.get('BACK_BTN_ID').substring(1) + '" class="sigfox-action-btn buttons-bar-button">Back</button>' + 
                                '<button type="button" id="' + this.CONSTANTS.get('NEXT_BTN_ID').substring(1) + '" class="sigfox-action-btn buttons-bar-button">Next</button>' + 
                            '</div>');
        
        this._bindButtons( $buttonsBar );
        this.$form.append($buttonsBar);
    };
    
    Wizard.prototype._bindButtons = function( $buttonsBar ){
        var here = this;
        
        $buttonsBar.children( this.CONSTANTS.get('BACK_BTN_ID') ).on('click', $.proxy(function( event ){
            event.preventDefault();
            var previous = this.options.getPreviousPageIndex(this);
            this.goToPageIndex( previous );
        }, here));
        
        $buttonsBar.children( this.CONSTANTS.get('NEXT_BTN_ID') ).on('click', $.proxy(function( event ){
            if( $(event.target).attr('type') === 'button' ){
                event.preventDefault();
            }
            var next = this.options.getNextPageIndex(this);
            this.goToPageIndex( next );
        }, here));
    };
    
    /**
     * THE method in this shady class.
     * - Hides the current page
     * - Shows the next page
     * - Updates page description
     * - Updates active step
     * - Updates buttons bar
     * 
     * SRP you said... GFY !
     */
    Wizard.prototype.goToPageIndex = function( index ){
        if( index === this.CONSTANTS.get('NONE')){
            return;
        }
        
        var page = this.pages[index]; 
        if(this.currentPageIndex !== this.CONSTANTS.get('NONE')){
            // No more errors as the user has seen the message
            this._setStepAsError( this.pages[this.currentPageIndex].id, false );
            
            this.pages[this.currentPageIndex].hide( function () {
                // Show the new page when the old one has been hidden
                page.show();                
            });
        } else{
            page.show();
        }
        
        // This step is no more marked as an error because user has seen 'the message'
        this._setStepAsError( page.id, false );
        this.currentPageIndex = index;
        
        // Show / hide page description
        var pageDescription = page.description;
        var $descPanel = this.$container.find('.wizard-description-panel');
        if( pageDescription ){
            $descPanel.text(pageDescription).removeClass('hidden').css('opacity', '1');            
        } else{
            $descPanel.css('opacity' , '0');
        }
        // Show / hide page icon
        var pageIconUrl = page.iconUrl;
        var $iconPanel = $('.wizard-description-icon');
        if( pageIconUrl ) {
            $iconPanel .attr('src', pageIconUrl).removeClass('hidden').css('opacity', '1');     
        } else{
            $iconPanel.css('opacity' , '0');
        }
        
        // Mark a Step as active in the steps bar
        this.$container.find('.active-step').removeClass('active-step');
        this.$container.find('.wizard-steps-bar [data-page-selector=' + page.id + ']').addClass('active-step');

        // Show/hide buttons if necessary
        // NEXT
        if( page.options.showNextButton ){
            var $nextBtn = this.$container.find( this.CONSTANTS.get('NEXT_BTN_ID') )
            if( this.pages.length - 1 === index ){
                $nextBtn.text( this.options.submitBtnText ).attr('type', 'submit');
            } else{
                $nextBtn.text('Next').attr('type', 'button');
            }
            $nextBtn.show();
        } else{
            this.$container.find( this.CONSTANTS.get('NEXT_BTN_ID') ).hide();
        }
        // BACK
        if( page.options.showPreviousButton ){
            this.$container.find( this.CONSTANTS.get('BACK_BTN_ID') ).show();
        } else{
            this.$container.find( this.CONSTANTS.get('BACK_BTN_ID') ).hide();
        }
    };
    
    Wizard.prototype._goToPage = function( page ){
        this.goToPageIndex(this.pages.indexOf(page));
    };
    
    Wizard.prototype._bindCustomTriggers = function(){
        var here = this;
        this.$container.find('[data-page-change-trigger]').each( function( index, elem ){
            var $elem = $(elem);
            var targetPageSelector = $elem.data('pageChangeTrigger');
            $elem.on('click', $.proxy(function( event ){
                
                // Look for the target page
                var targetPages = $.grep( this.pages, function ( elem, index ){
                    return elem.id === targetPageSelector; 
                });
               
                // shall be exactly one target page
                if( targetPages.length !== 1 ){
                    throw new Error('A page change trigger with target page ' + targetPageSelector + ' has ' + targetPages.length + ' targets. It shall have exactly ONE target page.');
                }
                
                var targetPage = targetPages[0];
                this._goToPage( targetPage );   
            }, here));
        });
    };
    
    Wizard.prototype._updateFormAttributes = function( enctype, action, method ){
        this.$form.attr( 'enctype', enctype );
        this.updateFormAction( action );
        this.$form.attr( 'method', method );
    };
    
    Wizard.prototype.updateFormAction = function ( action ){
        if( action ){
            this.$form.attr( 'action', action );
        } else {
            this.$form.removeAttr( 'action' );
        }
    };
    
    Wizard.prototype._displayErrors = function (){
        // First page on error
        var pageIndex = null;
        
        // Global errors
        this.$container.prepend($('span[id$=".errors"]').fadeIn().removeClass('hidden'));
        
        // Show error status (icon) on pages titles
        for (var i = 0; i < this.pages.length; i++) {
            if( this.pages[i].hasErrors() ){
                this._setStepAsError( this.pages[i].id, true );
                if( pageIndex === null ){
                    pageIndex = i;
                }
            }
        }
        
        return pageIndex || 0;
    };
    
    /**
     * Sets a step error status. Usually error status is removed when we leave/enter a page.
     */
    Wizard.prototype._setStepAsError = function ( pageId, containsError ){
        if( containsError ){
            this._getPageStep( pageId ).addClass('with-errors').attr('title', 'This page contains some fields on error');
        } else{
            this._getPageStep( pageId ).removeClass('with-errors').removeAttr('title');
            this.currentPageIndex !== this.CONSTANTS.get('NONE') && this.pages[this.currentPageIndex].clearErrors();
        }
    };
    
    Wizard.prototype._getPageStep = function ( pageId ){
        return this.$stepsBar.find( '[data-page-selector="' + pageId + '"]' );
    };
    
    return Wizard;
});
